module.exports = __webpack_public_path__ + "static/media/ABHA_Queue.656b1020.svg";